export const CONFIG_RESULT = 'CONFIG_RESULT';
export const CONFIG_SET_PROFILE = 'CONFIG_SET_PROFILE';
export const CONFIG_ERROR = 'CONFIG_ERROR';
export const CONFIG_RESET = 'CONFIG_RESET';
export const MENU_COLLAPSED = 'MENU_COLLAPSED';
export const MENU_EXPANDED= 'MENU_EXPANDED';
export const CONFIG_LOADING = 'CONFIG_LOADING';

